import "./Footer.scss"

export const Footer = () => {
  return (
    <div className="footer">
      <p>Copyright © 2022, Teluktu. All rights reserved.</p>
    </div>
  )
}
